module.exports = __webpack_public_path__ + "assets/radio-hover.3f407423.svg";